export default "__VITE_ASSET__DNS6hRCa__"